/**
 * @file コンポーネント：フル動画ページ決済情報ボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ButtonPayment = (props) => {
    /**
     * 決済情報ボタンクリック時の処理
     */
    const fnOnClickButtonPayment = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // 決済情報ポップアップを開く
        props.setIsOpenPopupPayment(true);
    };

    // Presenterに渡す
    return (
        <Presenter {...props} fnOnClickButtonPayment={fnOnClickButtonPayment} />
    );
};
